import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GungCommonModule } from 'gung-common';
import { PunchoutFormComponent } from '../components/checkout/punchout/punchout-form/punchout-form.component';
import { PunchoutLoginComponent } from '../components/checkout/punchout/punchout-login/punchout-login.component';
import { PunchoutOrderPlacedComponent } from '../components/checkout/punchout/punchout-order-placed/punchout-order-placed.component';
import { PunchoutSubmitStepComponent } from '../components/checkout/punchout/punchout-submit-step/punchout-submit-step.component';
import { CxmlPunchoutHandler } from '../services/punchout/handlers/cxml-punchout.handler';
import { OciPunchoutHandler } from '../services/punchout/handlers/oci-punchout.handler';
import { ProceedoOciPunchoutHandler } from '../services/punchout/handlers/proceedo-oci-punchout.handler';
import { PUNCHOUT_PROTOCOL_HANDLERS } from '../services/punchout/punchout.tokens';
import { punchoutHandlerProvider } from './punchout-handler.provider';

@NgModule({
  declarations: [
    PunchoutFormComponent,
    PunchoutLoginComponent,
    PunchoutOrderPlacedComponent,
    PunchoutSubmitStepComponent
  ],
  imports: [CommonModule, RouterModule, ReactiveFormsModule, FormsModule, TranslateModule, GungCommonModule],
  exports: [
    PunchoutFormComponent,
    PunchoutLoginComponent,
    PunchoutOrderPlacedComponent,
    PunchoutSubmitStepComponent
  ],
  providers: [
    OciPunchoutHandler,
    CxmlPunchoutHandler,
    ProceedoOciPunchoutHandler,
    // Default mappers in the registry. Customer apps register additional
    // mappers by adding their own `{ provide: PUNCHOUT_PROTOCOL_HANDLERS, … }`
    // multi-provider entry — see the example in `punchout.tokens.ts`.
    { provide: PUNCHOUT_PROTOCOL_HANDLERS, useExisting: OciPunchoutHandler, multi: true },
    { provide: PUNCHOUT_PROTOCOL_HANDLERS, useExisting: CxmlPunchoutHandler, multi: true },
    { provide: PUNCHOUT_PROTOCOL_HANDLERS, useExisting: ProceedoOciPunchoutHandler, multi: true },
    punchoutHandlerProvider
  ]
})
export class PunchoutModule {}
